/* eslint-disable import/no-named-as-default-member */
import { call, put, select } from 'redux-saga/effects'
import moment from 'moment'
import _ from 'lodash'
import firebase from '../config/firebase'
import DataValidationActions from '../reducers/hasuraDataValidationReducer'
import Hasura from '../config/hasura'

export function* getOrders({ startAt, endAt }) {
  try {
    const query = `
      query($startAt: numeric, $endAt: numeric){
        orders(where: {created_at: {_gte: $startAt, _lte: $endAt}}) {
          id
          firebase_key
          created_at
        }
      }
    `
    const variables = { startAt, endAt }
    const { orders: hasuraData } = yield call(Hasura.execute, query, variables)

    const merchantRef = firebase
      .database()
      .ref('orders')
      .orderByChild('created_at')
      .startAt(startAt)
      .endAt(endAt)

    const snapshot = yield call([merchantRef, merchantRef.once], 'value')
    const firebaseData = snapshot.val()

    const diffOrders = compareOrderData({ hasuraData, firebaseData, startAt, endAt })

    yield put(DataValidationActions.setOrders({ hasuraData, firebaseData, diffOrders }))
  } catch (err) {
    yield put(DataValidationActions.setOrderError(err))
  }
}

export function* getItems({ startAt, endAt }) {
  try {
    const query = `
      query{
        items {
          merchant_key
          firebase_key
          modified_at
        }
      }
    `
    const { items: hasuraData } = yield call(Hasura.execute, query)
    const merchantRef = firebase.database().ref('items')
    const snapshot = yield call([merchantRef, merchantRef.once], 'value')

    const firebaseData = snapshot.val()
    const diffItems = compareItemData({ hasuraData, firebaseData })
    yield put(DataValidationActions.setItems({ hasuraData, firebaseData, diffItems, startAt, endAt }))
  } catch (err) {
    yield put(DataValidationActions.setItemError(err))
  }
}

export function* reuploadOrders({ orderIds }) {
  try {
    const { diffOrders } = yield select(state => state.hasuraDataValidation)

    const orders = Object.values(diffOrders).flat()
    const orderLength = orderIds.length
    const dbRef = firebase.database().ref()
    for (let orderIdIndex = 0; orderIdIndex < orderLength; orderIdIndex++) {
      const updates = {}
      const orderId = orderIds[orderIdIndex]
      const order = orders.find(order => order.order_auto_generate_key === orderId)

      if (!order) {
        continue
      }
      const hasura_backup_count = (order.hasura_backup_count || 0) + 1
      updates[`orders/${order.order_auto_generate_key}/hasura_backup_count`] = hasura_backup_count
      if (updates) yield call([dbRef, dbRef.update], updates)
    }

    yield put(DataValidationActions.clearOrders())
  } catch (err) {
    throw err
  }
}

export function compareOrderData({ hasuraData, firebaseData, startAt, endAt }) {
  const fireOrderIds = _.map(firebaseData, o => o.order_auto_generate_key)
  const hasuOrderIds = hasuraData.map(o => o.firebase_key)

  const fireDiff = _.xor(fireOrderIds, hasuOrderIds)

  const diffOrders = _.chain(firebaseData)
    .filter(
      order =>
        _.inRange(order.created_at, startAt, endAt) &&
        ['delivered', 'rejected'].includes(order.status) &&
        fireDiff.includes(order.order_auto_generate_key)
    )
    .groupBy(order => moment(order.created_at).format('DD-MMM'))
    .value()

  return diffOrders
}

export function compareItemData({ hasuraData, firebaseData, startAt, endAt }) {
  const fireOrderIds = _.reduce(
    firebaseData,
    (accum, items, merchantKey) => {
      _.forEach(items, (item, itemKey) => {
        const { modified_at } = item
        if (!modified_at) {
          return
        }
        if (startAt <= modified_at && endAt > modified_at) {
          return
        }
        accum.push([itemKey, merchantKey, item.modified_at].join('|'))
      })
      return accum
    },
    []
  )

  const hasuOrderIds = hasuraData
    .filter(i => i.modified_at)
    .map(i => [i.firebase_key, i.merchant_key, i.modified_at].join('|'))

  const fireDiff = _.xor(fireOrderIds, hasuOrderIds)

  const diffOrders = _.groupBy(fireDiff, item => item.split('|')[1])

  return diffOrders
}



// WEBPACK FOOTER //
// ./src/sagas/hasuraDataValidationSaga.js